import { Helmet } from 'react-helmet-async';

const CriticalCSS = () => {
  const criticalCSS = `
    /* Critical CSS for above-the-fold content */
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
    
    /* Reset and base styles */
    *, *::before, *::after {
      box-sizing: border-box;
    }
    
    html {
      line-height: 1.15;
      -webkit-text-size-adjust: 100%;
      scroll-behavior: smooth;
    }
    
    body {
      margin: 0;
      font-family: Inter, system-ui, -apple-system, sans-serif;
      font-size: 16px;
      line-height: 1.6;
      color: hsl(224 71% 4%);
      background-color: hsl(0 0% 100%);
    }
    
    /* Hero section critical styles */
    .hero-container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 2rem 1rem;
    }
    
    .hero-content {
      text-align: center;
      padding: 3rem 0;
    }
    
    .hero-title {
      font-size: clamp(2.5rem, 5vw, 4rem);
      font-weight: 700;
      line-height: 1.2;
      margin: 0 0 1.5rem 0;
      background: linear-gradient(135deg, hsl(221 83% 53%), hsl(221 83% 58%));
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
    
    .hero-description {
      font-size: clamp(1.125rem, 2vw, 1.5rem);
      color: hsl(220 9% 46%);
      margin: 0 0 2rem 0;
      max-width: 600px;
      margin-left: auto;
      margin-right: auto;
    }
    
    .hero-cta {
      display: inline-flex;
      align-items: center;
      padding: 1rem 2rem;
      background: linear-gradient(135deg, hsl(221 83% 53%), hsl(210 100% 56%));
      color: white;
      text-decoration: none;
      border-radius: 0.75rem;
      font-weight: 600;
      font-size: 1.125rem;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      box-shadow: 0 4px 6px -1px hsla(221, 83%, 53%, 0.25);
    }
    
    .hero-cta:hover {
      transform: translateY(-2px);
      box-shadow: 0 10px 25px -5px hsla(221, 83%, 53%, 0.35);
    }
    
    /* Loading skeleton animation */
    @keyframes pulse {
      0%, 100% { opacity: 1; }
      50% { opacity: 0.5; }
    }
    
    .loading-skeleton {
      animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
      background-color: hsl(220 14% 96%);
      border-radius: 0.375rem;
    }
    
    /* Navigation critical styles */
    .nav-sticky {
      position: sticky;
      top: 0;
      z-index: 50;
      background-color: hsla(0, 0%, 100%, 0.95);
      backdrop-filter: blur(10px);
      border-bottom: 1px solid hsl(220 13% 91%);
    }
    
    /* Mobile responsive adjustments */
    @media (max-width: 768px) {
      .hero-title {
        font-size: 2.5rem;
      }
      
      .hero-description {
        font-size: 1.125rem;
      }
      
      .hero-cta {
        padding: 0.875rem 1.5rem;
        font-size: 1rem;
      }
    }
    
    /* Performance optimizations */
    img {
      max-width: 100%;
      height: auto;
    }
    
    .contain-layout {
      contain: layout;
    }
    
    .contain-paint {
      contain: paint;
    }
  `;

  return (
    <Helmet>
      <style>{criticalCSS}</style>
    </Helmet>
  );
};

export default CriticalCSS;